import React from 'react';
import { DownloadIcon } from 'lucide-react';
export const ImportFormatPreview = () => {
  // Sample data matching the image
  const headers = ['Date', 'Job Number', 'Job Name', 'Rate Type', 'Rate', 'Start Time', 'Truck Type', 'Pickup Location', 'Dump Location', 'Material', 'Foreman Name', 'Foreman Phone', 'Comments'];
  const sampleData = [['28-Jul', '123456', 'Phase 1', '', '', '700', 'Double Belt', 'Granite East', 'Woods Cross Hi Road Base', 'Wesley', '8018886660', 'see wesley upon arrival'], ['29-Jul', '123457', 'Phase 2', '', '', '701', 'Double Belt', 'Granite East', 'Woods Cross Hi Road Base', 'Wesley', '8018886661', 'see wesley upon arrival'], ['30-Jul', '123458', 'Phase 3', '', '', '702', 'Double Belt', 'Granite East', 'Woods Cross Hi Road Base', 'Wesley', '8018886662', 'see wesley upon arrival'], ['31-Jul', '123459', 'Phase 4', '', '', '703', 'Double Belt', 'Granite East', 'Woods Cross Hi Road Base', 'Wesley', '8018886663', 'see wesley upon arrival'], ['1-Aug', '123460', 'Phase 5', '', '', '704', 'Double Belt', 'Granite East', 'Woods Cross Hi Road Base', 'Wesley', '8018886664', 'see wesley upon arrival'], ['2-Aug', '123461', 'Phase 6', '', '', '705', 'Double Belt', 'Granite East', 'Woods Cross Hi Road Base', 'Wesley', '8018886665', 'see wesley upon arrival'], ['3-Aug', '123462', 'Phase 7', '', '', '706', 'Double Belt', 'Granite East', 'Woods Cross Hi Road Base', 'Wesley', '8018886666', 'see wesley upon arrival'], ['4-Aug', '123463', 'Phase 8', '', '', '707', 'Double Belt', 'Granite East', 'Woods Cross Hi Road Base', 'Wesley', '8018886667', 'see wesley upon arrival'], ['5-Aug', '123464', 'Phase 9', '', '', '708', 'Double Belt', 'Granite East', 'Woods Cross Hi Road Base', 'Wesley', '8018886668', 'see wesley upon arrival']];
  return <div data-id="element-1813">
      <h3 className="text-lg font-medium mb-4" data-id="element-1814">Excel Import Format</h3>
      <div className="mb-4 flex items-center justify-between" data-id="element-1815">
        <p className="text-gray-600" data-id="element-1816">
          Your Excel file must have these exact column headers in the first row.
        </p>
        <button className="flex items-center gap-1 text-blue-600 hover:text-blue-800" onClick={() => alert('Template download would start here')} data-id="element-1817">
          <DownloadIcon size={16} data-id="element-1818" />
          <span data-id="element-1819">Download Template</span>
        </button>
      </div>
      <div className="border rounded-md overflow-hidden mb-6" data-id="element-1820">
        <div className="bg-green-700 h-6" data-id="element-1821"></div>
        <div className="overflow-x-auto" data-id="element-1822">
          <table className="min-w-full" data-id="element-1823">
            <thead data-id="element-1824">
              <tr className="bg-gray-100" data-id="element-1825">
                {headers.map((header, index) => <th key={index} className="px-4 py-2 text-left text-xs font-medium text-gray-600 uppercase tracking-wider border-r border-b" data-id="element-1826">
                    {header}
                  </th>)}
              </tr>
            </thead>
            <tbody data-id="element-1827">
              {sampleData.map((row, rowIndex) => <tr key={rowIndex} className={rowIndex % 2 === 0 ? 'bg-white' : 'bg-gray-50'} data-id="element-1828">
                  {row.map((cell, cellIndex) => <td key={cellIndex} className="px-4 py-2 text-sm border-r border-b" data-id="element-1829">
                      {cell}
                    </td>)}
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
      <div className="bg-gray-50 border rounded-md p-4" data-id="element-1830">
        <h4 className="font-medium mb-2" data-id="element-1831">Required Fields</h4>
        <ul className="list-disc pl-5 text-sm space-y-1" data-id="element-1832">
          <li data-id="element-1833">
            <strong data-id="element-1834">Date:</strong> The date of the job (format: DD-MMM or
            MM/DD/YYYY)
          </li>
          <li data-id="element-1835">
            <strong data-id="element-1836">Job Number:</strong> A unique identifier for the job
          </li>
          <li data-id="element-1837">
            <strong data-id="element-1838">Job Name:</strong> The name or description of the job
          </li>
          <li data-id="element-1839">
            <strong data-id="element-1840">Rate Type:</strong> Either "Hourly" or "Per Load"
          </li>
          <li data-id="element-1841">
            <strong data-id="element-1842">Rate:</strong> The rate amount (numeric value)
          </li>
          <li data-id="element-1843">
            <strong data-id="element-1844">Start Time:</strong> The job start time (format: HHmm, e.g.
            700 for 7:00 AM)
          </li>
          <li data-id="element-1845">
            <strong data-id="element-1846">Truck Type:</strong> The type of truck required (e.g.,
            "Double Belt")
          </li>
          <li data-id="element-1847">
            <strong data-id="element-1848">Pickup Location:</strong> Where materials will be picked up
          </li>
          <li data-id="element-1849">
            <strong data-id="element-1850">Dump Location:</strong> Where materials will be dumped
          </li>
          <li data-id="element-1851">
            <strong data-id="element-1852">Material:</strong> The type of material being transported
          </li>
        </ul>
        <h4 className="font-medium mt-4 mb-2" data-id="element-1853">Optional Fields</h4>
        <ul className="list-disc pl-5 text-sm space-y-1" data-id="element-1854">
          <li data-id="element-1855">
            <strong data-id="element-1856">Foreman Name:</strong> The name of the foreman on site
          </li>
          <li data-id="element-1857">
            <strong data-id="element-1858">Foreman Phone:</strong> Contact number for the foreman
          </li>
          <li data-id="element-1859">
            <strong data-id="element-1860">Comments:</strong> Any additional information or
            instructions
          </li>
        </ul>
      </div>
    </div>;
};